var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.totalCount > 0)?_c('div',{staticClass:"text-xs mb-4"},[_vm._v(" "+_vm._s(_vm.totalCountText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }